import React from "react";
import { useTranslation } from "react-i18next";

import {
  Form,
  Input,
  Row,
  Col
} from '@lockerpm/design';

import global from "../../config/global";

const BillingContact = (props) => {
  const {
    className = ''
  } = props
  const { t } = useTranslation()
  return (
    <div className={`billing-contact ${className}`}>
      <p className="text-[16px] font-semibold mb-6">
        {t('billing.billing_contact')}
      </p>
      <Row gutter={[24, 0]}>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            name="contact_name"
            label={<p className="font-semibold">
              {t('common.name')}
            </p>}
            rules={[
              global.rules.REQUIRED(t('common.name')),
            ]}
          >
            <Input
              placeholder={t('placeholder.name')}
            />
          </Form.Item>
        </Col>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            className="mb-0"
            name="contact_email"
            label={<p className="font-semibold">
              {t('common.email')}
            </p>}
            rules={[
              global.rules.REQUIRED(t('common.email')),
              global.rules.INVALID(t('common.email'), 'EMAIL')
            ]}
          >
            <Input
              placeholder={t('placeholder.email')}
            />
          </Form.Item>
          <p className="text-[12px] text-black-600 mt-1 mb-4">
            {t('billing.email_hint')}
          </p>
        </Col>
      </Row>
      <Form.Item
        name="contact_company"
        label={<p className="font-semibold">
          {t('common.company')}
        </p>}
        rules={[]}
      >
        <Input
          placeholder={t('placeholder.company')}
        />
      </Form.Item>
    </div>
  );
}

export default BillingContact;